import { AnaColumn } from "../forms-template.service";
import { gridSimple } from "./gridSettings/gridSettings";



export const RintraccMiscelazione:AnaColumn[] = [
  {
    itemType: "group", colSpan: '8', caption: "",
    groupDataField: 'datiMiscelazione',

    data: [

      {
        type: 'campo',
        colVisible: true,
        allowEditing: true,
        dataField: "lega",
        colWidth: '30',
        caption: "Lega",
        dataType: 'boolean',
        editorType: 'checkBox',
        showEditorAlways: true,
        class: 'legame-checkbox'
      },

      {
        type: 'campo',
        dataField: "legaChiudi",
        dataType: "boolean",
        caption: "Chiudi",
        colWidth: '35',
        colVisible: true,
        labelVisible: true,
        editorType: 'checkBox',
        allowEditing: true,
        showEditorAlways: true,
        class: 'legame-checkbox'
      },

      {
        type: 'campoSpecial',
        colVisible: true,
        allowEditing: false,
        dataField: "eer",
        colWidth: '65',
        orderGriglia: 7,

        maxLength: '6',
        caption: "EER",
        disableOnUpdate: false,
        dynamic: {
          valueExpr: 'id',
          queryString: '',
          displayExpr: '',
          dataSource: 'cer',
          service: 'cer',
          filterStatic: "?$filter=(not endswith(id,'00'))",
          autocomplete: false,
          caption: "Lista EER",
          componentType: 'NicaDataGridComponent',
          buttonOption: {
            text: 'Codici CER',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Lista codici CER',
            name: 'CodiciCERLista',
            location: 'after',
          },
          settingGrid: gridSimple


        },
        validation: [
          { type: 'required', message: 'EER campo obbligatorio' }
        ]
      },
      {
        type: 'campoSpecial', dataField: "idStatoFisico", dataType: "", caption: "SF",
        colWidth: '25',
        colVisible: true,
        labelVisible: true,
        orderGriglia: 9,
        class: 'stato-fisico',
        showClearButton: false,
        maxLength: '2',
        allowEditing: false,
        dynamic: {
          valueExpr: 'id',
          queryString: '',
          displayExpr: '',
          dataSource: 'StatoFisico',
          service: 'generic',
          autocomplete: false,
          caption: "Lista Stati Fisici",
          componentType:'dynamicGrid',
          buttonOption: {
            text: 'Lista Stati Fisici',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Lista Stati Fisici',
            name: 'StatoFisico',
            location: 'after',
          },
          settingGrid: gridSimple

        },
        validation: [
          { type: 'required', message: 'Stato fisico obbligatorio' }
        ]
      },
      {
        type: 'campo',
        dataField: "riferimentoEER",
        dataType: "dateTime",
        caption: "Rif.EER",
        colWidth: '70',
        colVisible: true,
        labelVisible: true,
        allowEditing: false,
        maxLength: '10',
      },
      {
        type: 'campo',
        dataField: "dataRegistrazione",
        dataType: "dateTime",
        caption: "Data Reg.",
        colWidth: '70',
        colVisible: true,
        labelVisible: true,
        allowEditing: false,
      },
      {
        type: 'campoSpecial',
        dataField: "causaleRifiuto_Descizione",
        dataType: "",
        caption: "Causale rifiuti",
        colVisible: true,
        labelVisible: true,
        orderGriglia: 9,
        disableOnUpdate: true,
        allowEditing: false,
        colWidth: '135',
        dynamic: {
          valueExpr: '',
          queryString: "?IdPosizioneRifiuto=$idPosizioneRifiuto",

          displayExpr: 'descrizione',
          dataSource: 'CausaleRifiuti/GetCausaliRifiutiByPosizione',
          autocomplete: false,
          componentType: 'NicaDataGridComponent',
          related: ['id|idCausaleRifiuto'],
          buttonOption: {
            text: 'StatoFisico',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista StatoFisico',
            name: 'StatoFisico',
            location: 'after',
          },
          settingGrid: gridSimple
        },
        validation: [
          { type: 'required', message: 'Causale obbligatoria' }
        ]
      },
      {
        type: 'campoSpecial',
        dataField: "operazioneRD",
        dataType: "",
        caption: "Op.",
        colVisible: true,
        labelVisible: true,
        colWidth: '40',
        maxLength: '3',
        disableOnUpdate: true,
        showInColumnChooser: false,
        allowEditing: false,
        dynamic: {
          dataSource: 'OperazioneSmaltimento',
          service: 'OperazioneSmaltimento',
          autocomplete: false,
          valueExpr: '',
          displayExpr: 'id',
          caption: "Lista Operazioni Smaltimento e Recupero",
          queryString: '',
          filter: '',
          componentType: 'NicaDataGridComponent',
          //related: ['id|operazioneRD'],

          buttonOption: {
            text: 'Modalità di Stoccaggio',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Mod.Stoccaggio',
            name: 'stoccaggio',
            location: 'after',

          },
          settingGrid: gridSimple

        },
        validation: [
          { type: 'required', message: 'Operazione obbligatoria' }
        ]
      },


      {
        type: 'button',
        dataField: "“proponiIncidenza",
        dataType: "",
        caption: "Proponi Incidenza",
        colWidth: '90',
        allowEditing: false,
        colVisible:false,
        button:{
          icon:'mdi mdi-vector-combine',
          text:'incide',
          name:'incide',
          hint:'proponi automaticamente..',
          event:'proponiIncidenza'
        }
      },

      {
        type: 'campo',
        dataField: "quantitaTrattata",
        format: "#,##0.00",
        dataType: "",
        editorType: 'dxNumberBox',
        caption: "Di cui abbinati(Kg)",
        min: 0,
        max: 100,
        maxLength: '7',
        colWidth: '95',
        allowEditing: false,
      },

      {
        type: 'campo',
        dataField: "percentuale",
        format: "#,##0.00",
        dataType: "",
        colVisible: false,
        caption: "Incide per(%)",
        class: 'legame-checkbox',
        colWidth: '60',
        maxLength: '3',
        allowEditing: true,
        disableOnUpdate: true
      },
      
      {
        type: 'campo',
        dataField: "quantita",
        format: "#,##0.00",
        editorType: 'number',
        caption: "Incide per(Kg)",
        colWidth: '80',
        maxLength: '7',
        allowEditing: true,
        showClearButton:false,
        showInSummary:true,
      },

    ]
  },]
